import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCXousb5pmBkBkn7w0RzHVMti1gPQHcyeM",
  authDomain: "estudio9-7f062.firebaseapp.com",
  databaseURL: "https://estudio9-7f062.firebaseio.com",
  projectId: "estudio9-7f062",
  storageBucket: "estudio9-7f062.appspot.com",
  messagingSenderId: "825369633512",
  appId: "1:825369633512:web:ae19d8f93f92809a9b5f5d"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Get a Firestore instance
export const db = firebase.firestore();
